import { useEffect } from 'react';
import { shallowEqual, useDispatch } from 'react-redux';

import { useSelector } from '../../selectors/useSelector';

import { updateIsWizardView } from '../../slices/app';

import PropertiesPage from '../PropertiesPage';
import { ZRAMPropertiesPage } from '../ZRAMPropertiesPage';

const PropertiesPageWrapper = () => {
  const dispatch = useDispatch();

  const { isEnterpriseCustomer, isWizardView } = useSelector(
    (state) => ({
      isEnterpriseCustomer: state?.user?.isEnterpriseCustomer ?? false,
      isWizardView: state?.app?.isWizardView ?? false,
    }),
    shallowEqual,
  );

  useEffect(() => {
    /**
     * Properties page is not supported in the wizard view
     */
    if (isWizardView) {
      dispatch(updateIsWizardView(false));

      return;
    }
  }, []);

  if (isEnterpriseCustomer) {
    return <ZRAMPropertiesPage />;
  }

  return <PropertiesPage />;
};

export default PropertiesPageWrapper;
